import { Fragment } from "react";
import { Tile } from "../Tile";
import Magazine from "../../svg/magazine.svg";
import MemberDiscount from "../../svg/member-discount.svg";
import RentalCoverage from "../../svg/rental-coverage.svg";
import RoadsideService from "../../svg/roadside-service.svg";
import styles from "./DriversClub.module.scss";
import { useDialog } from "../Dialog";
import cx from "clsx";
import { DriversClub1Dot0, DriversClub1Dot5 } from "shared";
import { useUrls } from "../../app/Providers/AppContext";
import { RoadsideHelpDialog } from "./RoadsideHelpDialog";
import { TagAction } from "../../types/TagAction.types";

const { origin } = window.location;

const blankTile = (
  <Tile icon={<Fragment />} className={styles.blankTile} cta="" />
);

type DriversClubTilesProps = {
  hdc: DriversClub1Dot0 | DriversClub1Dot5;
};

export const DriversClubTiles = ({ hdc }: DriversClubTilesProps) => {
  const urls = useUrls();

  const roadSideDialog = useDialog();

  const { hdcVersion, benefits } = hdc;

  const isHdcOneDotZero = hdcVersion === "1.0";
  const action = isHdcOneDotZero
    ? "hdc_10_link_clicked"
    : "hdc_15_link_clicked";

  const roadsidePhoneTagAction: TagAction = {
    name: "roadside_phone",
    action,
  };

  const roadsideTile = (
    <Tile
      icon={
        <img src={RoadsideService} alt="Roadside Service" aria-hidden="true" />
      }
      cta="Get roadside help"
      tagAction={{ name: "roadside_help", action }}
      onClick={roadSideDialog.open}
    />
  );

  const driversClubIdTile = (
    <Tile
      icon={
        <img src={RentalCoverage} alt="Rental coverage" aria-hidden="true" />
      }
      cta="Drivers Club ID"
      ariaLabel="Access Drivers Club ID"
      href={urls.hdc.viewMembershipCard(origin)}
      tagAction={{ name: "id", action }}
      newTab
    />
  );

  const redeemBenefitsTile = (
    <Tile
      icon={<img src={Magazine} alt="Redeem benefits" aria-hidden="true" />}
      cta="Redeem benefits"
      href={urls.hdc.redeemBenefits}
      tagAction={{ name: "redeem_benefits", action }}
    />
  );

  const plansTile = isHdcOneDotZero ? (
    <Tile
      icon={<img src={MemberDiscount} alt="See all plans" aria-hidden="true" />}
      cta="See all plans"
      href={urls.hdc.seeAllPlans}
      tagAction={{ name: "see_plans", action: "hdc_10_link_clicked" }}
    />
  ) : (
    <Tile
      icon={
        <img src={MemberDiscount} alt="Upgrade or Cancel" aria-hidden="true" />
      }
      cta="Upgrade or cancel"
      href={urls.hdc.upgradeOrCancel}
      tagAction={{ name: "upgrade_cancel", action: "hdc_15_link_clicked" }}
    />
  );

  // Render driversClubIdTile if the user has benefits, otherwise render blankTile at the end
  const rowOne = benefits ? (
    <>
      {roadsideTile}
      {driversClubIdTile}
    </>
  ) : (
    <>
      {driversClubIdTile}
      {redeemBenefitsTile}
    </>
  );

  const rowTwo = benefits ? (
    <>
      {redeemBenefitsTile}
      {plansTile}
    </>
  ) : (
    <>
      {plansTile}
      {blankTile}
    </>
  );

  return (
    <>
      <div className={cx(styles.row, styles.rowWrapper)}>
        <div className={styles.row}>{rowOne}</div>
        <div className={cx(styles.row, styles.secondRow)}>{rowTwo}</div>
      </div>

      {roadSideDialog.isOpen && (
        <RoadsideHelpDialog
          roadsidePhoneTagAction={roadsidePhoneTagAction}
          onDismiss={roadSideDialog.close}
        />
      )}
    </>
  );
};
